"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SplitPane = exports.SplitPaneResizer = void 0;
const tslib_1 = require("tslib");
const styled_1 = tslib_1.__importDefault(require("@emotion/styled"));
const React = tslib_1.__importStar(require("react"));
const react_draggable_1 = require("react-draggable");
const styled_tools_1 = require("styled-tools");
const wrapperFunc = (lr, size) => {
    let grid;
    if (lr) {
        grid = `
          'left resizer right' 1fr
          / calc(${size * 100}% - 1px) 1px calc(${(1 - size) * 100}% - 1px)
      `;
    }
    else {
        grid = `
        'top' ${size}fr
        'resizer' 1px
        'bottom' ${1 - size}fr
        / 1fr
    `;
    }
    return {
        grid,
    };
};
const wrapperWithProps = styled_tools_1.withProp(['lr', 'size'], wrapperFunc);
const Wrapper = styled_1.default('div') `
  display: grid;
  min-height: 0;
  ${wrapperWithProps}
`;
exports.SplitPaneResizer = styled_1.default.div `
  background-color: ${styled_tools_1.prop('theme.gray5')};
  background-clip: padding-box;
  box-sizing: border-box;
  z-index: 30;

  &:hover {
    transition: all 0.3s ease;
  }
`;
const SplitPaneResizerLR = styled_1.default(exports.SplitPaneResizer) `
  margin: 0 -5px;
  cursor: col-resize;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;

  &:hover {
    border-left: 5px solid rgba(64, 56, 76, 0.5);
    border-right: 5px solid rgba(64, 56, 76, 0.5);
  }
`;
const SplitPaneResizerTB = styled_1.default(exports.SplitPaneResizer) `
  margin: -5px 0;
  cursor: row-resize;
  border-top: 5px solid transparent;
  border-bottom: 5px solid transparent;

  &:hover {
    border-top: 5px solid rgba(64, 56, 76, 0.5);
    border-bottom: 5px solid rgba(64, 56, 76, 0.5);
  }
`;
class SplitPane extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {
            active: false,
            size: this.props.initialSize,
        };
        this.wrapperRef = React.createRef();
        this.onStartDrag = () => {
            const { onExpandRight, collapseRight } = this.props;
            this.setState({ active: true, size: collapseRight ? 1.0 : this.state.size });
            if (onExpandRight !== undefined) {
                onExpandRight();
            }
        };
        this.onDrag = (_event, data) => {
            const wrapper = this.wrapperRef.current;
            if (wrapper !== null) {
                const totalSize = this.props.type === 'lr' ? wrapper.clientWidth : wrapper.clientHeight;
                const delta = this.props.type === 'lr' ? data.deltaX : data.deltaY;
                const size = Math.max(Math.min(this.state.size + delta / totalSize, 1), 0);
                this.setState({ size });
            }
        };
        this.onStopDrag = () => {
            this.setState({ active: false });
        };
    }
    render() {
        const _a = this.props, { type, left, right, top, bottom, initialSize: _initialSize, collapseRight, onExpandRight: _onExpandRight } = _a, props = tslib_1.__rest(_a, ["type", "left", "right", "top", "bottom", "initialSize", "collapseRight", "onExpandRight"]);
        const { active } = this.state;
        let { size } = this.state;
        let first;
        let second;
        if (type === 'lr') {
            first = left;
            second = right;
            size = collapseRight ? 1.0 : size;
        }
        else {
            first = top;
            second = bottom;
        }
        const lr = type === 'lr';
        if (active) {
            first = React.cloneElement(first, { style: { pointerEvents: 'none' } });
            second = React.cloneElement(second, { style: { pointerEvents: 'none' } });
        }
        return (React.createElement(Wrapper, Object.assign({ ref: this.wrapperRef, lr: lr, size: size }, props),
            first,
            React.createElement(react_draggable_1.DraggableCore, { onStart: this.onStartDrag, onDrag: this.onDrag, onStop: this.onStopDrag }, lr ? React.createElement(SplitPaneResizerLR, null) : React.createElement(SplitPaneResizerTB, null)),
            second));
    }
}
exports.SplitPane = SplitPane;

//# sourceMappingURL=SplitPane.js.map
